import {withRouter} from 'react-router-dom';

const StartTesting = ({history}) => {
  localStorage.setItem('isTestRunning', 0);
  history.push('/testing');
  return '';
};

export default withRouter(StartTesting);
